import Splitting from 'splitting';

export default class Animation {
  constructor({
    query = '.site-animation',
    titleQuery = '[data-animation="title"]',
    defaultDelay = 100,
    rootMargin = '0px 0px -10% 0px',
    threshold = 0,
  } = {}) {
    this.elements = document.querySelectorAll(query);
    this.titles = [...document.querySelectorAll(titleQuery)];

    this.defaultDelay = defaultDelay;
    this.rootMargin = rootMargin;
    this.threshold = threshold;

    if (this.elements.length) {

      this.init();
    }

    if (this.titles.length) {
      this.initTitles();
    }
  }

  init() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      {
        root: null,
        threshold: this.threshold,
        rootMargin: this.rootMargin,
      }
    );

    this.elements.forEach((el) => {
      this.observer.observe(el);
    });
  }

  initTitles() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const splitBy = isMobile ? 'words' : 'chars';
    const partSelector = isMobile ? '.word' : '.char';

    Splitting({
      target: this.titles,
      by: splitBy,
    });

    this.titles.forEach((el) => {
      const parts = el.querySelectorAll(partSelector);

      parts.forEach((node, i) => {
        node.style.setProperty('--char-index', i);
      });
    });

    this.titleObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-active');
          this.titleObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: this.threshold,
        rootMargin: this.rootMargin,
      }
    );

    this.titles.forEach((el) => {
      this.titleObserver.observe(el);
    });
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const element = entry.target;
      const delay = this.getDelay(element);

      setTimeout(() => {
        element.classList.add('animated');
      }, delay);

      this.observer.unobserve(element);
    });
  }

  getDelay(element) {
    if (element.dataset.delay) {
      const parsed = Number(element.dataset.delay);

      if (!Number.isNaN(parsed) && parsed >= 0) {
        return parsed;
      }
    }

    return this.defaultDelay;
  }
}